
// accouncement slider
class SwiperComponents extends HTMLElement {
    constructor() {
      super();
      this.slideInterval = this.getAttribute('data-slide-interval');

      this.swiperSlide();
    }

    swiperSlide() {
      var swiper = new Swiper(this, {
        slidesPerView: 1,
        spaceBetween: 0,
        loop: true,
        centeredSlides: true,
        autoplay: {
          delay: this.slideInterval,
          disableOnInteraction: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        }
      });
    }
  }

  customElements.define('announcement-slide', SwiperComponents);
